import swischIcon from '@/assets/swish.svg';
import { cn } from '@/utils';
import { CSSProperties } from 'react';

export const SwishIcon = (
  { className = '', style }: { className?: string; style?: CSSProperties } = { className: '', style: {} }
) => <img src={swischIcon} style={style} alt="Swish ikon" className={cn('w-4 h-4 mr-2', className)} />;
